import type { WorkLogPage } from '../components/worklog/types';
import { client } from './api';
import { getPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGet } from './api/sdk.gen';

/**
 * A payer's NOA rules, as staff manage them.
 *
 * Reached only from Internal Tools, which already requires a Strawhat super
 * user. null means the payer has no opinion; an insurance that does not
 * override a rule then sends NOAs as it did before.
 */
export interface PayorNoaSettings {
  id: string;
  payor_name: string;
  electronic_payor_id: string | null;
  is_active: boolean;
  noa_include_location_codes: boolean | null;
  noa_omit_admitting_diagnosis: boolean | null;
}

export async function searchPayorNoaSettings(
  search: string
): Promise<PayorNoaSettings[]> {
  const response = await client.get<PayorNoaSettings[], unknown, true>({
    query: { search, limit: 50 },
    responseType: 'json',
    throwOnError: true,
    url: '/internal-tools/payors',
  });
  return response.data;
}

export async function updatePayorNoaSettings(
  id: string,
  changes: {
    noa_include_location_codes?: boolean | null;
    noa_omit_admitting_diagnosis?: boolean | null;
  }
): Promise<PayorNoaSettings> {
  const response = await client.patch<PayorNoaSettings, unknown, true>({
    body: changes,
    responseType: 'json',
    throwOnError: true,
    url: `/internal-tools/payors/${id}/noa-settings`,
  });
  return response.data;
}

/** The payor's rule changes as a work log page; the endpoint takes no cursor. */
export async function loadPayorNoaWorkLog(id: string): Promise<WorkLogPage> {
  const response =
    await getPayorNoaSettingsHistoryInternalToolsPayorsPayorIdNoaSettingsHistoryGet(
      {
        path: { payor_id: id },
        client,
        throwOnError: true,
      }
    );
  return { work_log: response.data.work_log, next_cursor: null };
}
